export enum PromoOptionTypeEnum {
  Animated = 1,
  Static = 2,
  HTML5 = 3,
}
